export default __webpack_public_path__ + "static/media/programmer-male.318dd5c2.png";